import { createAction } from '@reduxjs/toolkit';

export const logMesssage = createAction<string>('[Logging] Log Message');
